import type { ReactNode } from "react";

import { Box, BoxProps, Text, TextProps } from "@chakra-ui/react";

export interface LabelValProps extends BoxProps {
  label: string;
  value: ReactNode;

  labelProps?: TextProps;
  valueProps?: TextProps;
}

export const LabelVal = ({
  label,
  value,
  labelProps,
  valueProps,
  ...props
}: LabelValProps) => {
  return (
    <Box w="full" h="full" {...props}>
      <Text fontSize="md" fontWeight="medium" {...valueProps}>
        {value}
      </Text>
      <Text fontSize="xs" color="subtle" {...labelProps}>
        {label}
      </Text>
      {props.children}
    </Box>
  );
};
